<template>
	<div class="home">
		<top></top>
		<left></left>
		<lbt></lbt>
		<bar></bar>
	</div>
</template>

<script>
	import top from '@/components/top.vue'
	import left from '@/components/left.vue'
	import lbt from '@/components/lbt.vue'
	import bar from '@/components/index-bar.vue'
	export default {
		name: 'HomeView',
		components: {
			top,
			left,
			lbt,
			bar,
		},
		data() {
			return {
				
			}
		},
		methods:{
			
		}
	}
</script>
<style scoped lang="less">
	.home{
		width: 1920px;
		height: 100vh;
		overflow: hidden;
		position: relative;
	}
	
	
	
	
	
</style>